import { Link } from 'react-router-dom';
import ManhwaCard from '@/components/feature/ManhwaCard';
import { manhwaList } from '@/mocks/manhwa';

export default function PopularSection() {
  const popular = [...manhwaList]
    .sort((a, b) => b.rating - a.rating)
    .slice(0, 8);

  return (
    <section id="popular" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
          <div>
            <p className="text-xs font-medium tracking-widest text-accent-600 mb-2">编辑精选</p>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">人气韩漫推荐</h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base">高评分、高口碑的韩漫都在这里，不知道看什么就从这份榜单开始。</p>
          </div>
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {popular.map((m) => (
            <ManhwaCard key={m.id} manhwa={m} />
          ))}
        </div>
      </div>
    </section>
  );
}